import { GridIcon } from './GridIcon';

/**
 * author: Google
 * id 8D4C203D-A1F0-42DA-997A-AB7BAC63D97B
 * name grid
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/grid.svg
 * tags
 */
export const GridOnIcon = GridIcon;
export default GridOnIcon